export const HEADER_HEIGHT = '60px';
export const FOOTER_HEIGHT = '80px';

export const COLORS = {
  WHITE: '#fff',
  BLACK: '#000',
  BLUE: '#268bd2',
  RED: '#dc2f2f',
  GREEN: '#859900',
};



// WEBPACK FOOTER //
// ./src/constants/styles.js